import type { AttendanceCapture } from '../types/faceAttendance';

export type MobileCaptureRequest = {
  captured: (capture: AttendanceCapture) => void;
  failed: (message: string, code?: string) => void;
};
type CaptureHost = (request: MobileCaptureRequest | null) => void;
let host: CaptureHost | null = null;
let active: MobileCaptureRequest | null = null;
let canceled: Error | null = null;

export function registerMobileAttendanceCapture(next: CaptureHost) {
  host = next;
  return () => {
    if (host !== next) return;
    active?.failed(
      'Face verification was cancelled. Please try again.',
      'CAPTURE_CANCELED',
    );
    host = null;
  };
}

export function requestMobileAttendanceCapture(): Promise<AttendanceCapture> {
  if (!host)
    return Promise.reject(
      Object.assign(new Error('Sign in to verify your face.'), {
        code: 'CAPTURE_UNAVAILABLE',
      }),
    );
  if (active)
    return Promise.reject(
      Object.assign(new Error('Face verification is already in progress.'), {
        code: 'FACE_VERIFICATION_IN_PROGRESS',
      }),
    );
  canceled = null;
  return new Promise((resolve, reject) => {
    active = {
      captured: resolve,
      failed: (message, code = 'CAPTURE_FAILED') => {
        canceled = Object.assign(new Error(message), { code });
        reject(canceled);
        host?.(null);
      },
    };
    host!(active);
  });
}

export function assertMobileAttendanceCaptureActive() {
  if (canceled) throw canceled;
  if (!active || !host)
    throw Object.assign(new Error('Face verification was cancelled.'), {
      code: 'CAPTURE_CANCELED',
    });
}

export function closeMobileAttendanceCapture() {
  active = null;
  host?.(null);
}
